import ImageDetailController from './image.detail.controller';

export default {
    template: require('./image.detail.html'),
    controller: ImageDetailController
};
